// Actual root file of this App.

import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import 
//registerServiceWorker, 
{ unregister } from "./registerServiceWorker";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import { restTransciever } from "./api/restTransciever";
import { socketTransciever } from "./api/socketTransciever";

import './i18n';

import { BASEURL } from "./helpers/constants";

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunk)
  // other store enhancers if any
);

const store = createStore(rootReducer, enhancer);

restTransciever(BASEURL, store);
socketTransciever(BASEURL, store);

// Tranlations


ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

//registerServiceWorker();
unregister();
